module.exports = __webpack_public_path__ + "img/Pets-01.30e97f0b.png";